import { Component, Inject, OnInit } from '@angular/core';
import { Notification } from '../../../core/services/notification.service';
import {
	MAT_DIALOG_DATA,
	MatDialogConfig,
	MatDialogRef,
} from '@angular/material/dialog';
import { formatDistanceToNow } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import { Router } from '@angular/router';

@Component({
	selector: 'app-notifications',
	templateUrl: './notifications.component.html',
	styleUrls: ['./notifications.component.scss'],
})
export class NotificationsComponent implements OnInit {
	notifications: Notification[];
	private readonly _matDialogRef: MatDialogRef<NotificationsComponent>;

	constructor(
		_matDialogRef: MatDialogRef<NotificationsComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private router: Router
	) {
		this._matDialogRef = _matDialogRef;
	}

	ngOnInit(): void {
		const matDialogConfig: MatDialogConfig = new MatDialogConfig();
		matDialogConfig.position = { right: '4em', top: '4em' };
		this._matDialogRef.updatePosition(matDialogConfig.position);

		this.notifications = this.data.notifications;
	}

	navigateToDetails(id: string): void {
		this._matDialogRef.close();
		this.router.navigate(['/home/ocurrences-details', id]);
	}

	convertToPtText(date: Date): string {
		return formatDistanceToNow(date, { locale: ptBR });
	}
}
